import VueRamUtils from "vue-ram-utils";
import settings from "./settings";

const axios_token = VueRamUtils.axios_token;

export default {
  update_term: (context, term) => {
    console.info("update_term", context, term);
    context.commit("set_term", term.trim());
    if (context.state.term.trim()) context.dispatch("search");
  },
  update_search_type: (context, search_type) => {
    console.info("update_search_type", context, search_type);
    context.commit("set_search_type", search_type);
    if (context.state.term) context.dispatch("search");
  },
  set_searching: (context, value) => {
    context.commit("set_searching", value);
  },
  next_page: (context) => {
    context.commit("set_searching", true);
    console.info("next_page begin");
    let extra_args = {};
    if (settings[context.state.search_type].args) {
      extra_args = settings[context.state.search_type].args;
    }
    let query_el = new URLSearchParams({
      ...extra_args,
      term: context.state.term,
      page: context.state.curpage + 1,
    });
    const url = settings[context.state.search_type].url;
    return axios_token
      .get(url + "?" + query_el.toString())
      .then((response) => response.data)
      .then(function (data) {
        console.info("next_page get", data);
        context.commit("append_results", data.results);
        context.commit(
          "set_has_other_data",
          context.state.curpage * data.per_page < data.count
        );
        return data;
      })
      .catch((reason) => {
        console.info("next_page catch", reason);
        context.commit("set_results", []);
      });
  },
  search: (context) => {
    console.info("search begin");
    context.commit("set_has_other_data", false);
    context.commit("set_searching", true);
    let extra_args = {};
    if (settings[context.state.search_type].args) {
      extra_args = settings[context.state.search_type].args;
    }
    let query_el = new URLSearchParams({
      ...extra_args,
      term: context.state.term,
    });
    const url = settings[context.state.search_type].url;
    return axios_token
      .get(url + "?" + query_el.toString())
      .then((response) => response.data)
      .then(function (data) {
        if (data.results) {
          console.info("search get", data);
          context.commit("set_results", data.results);
          context.commit(
            "set_has_other_data",
            context.state.curpage * data.per_page < data.count
          );

          return data;
        } else {
          console.info("search get", data);
          context.commit("set_results", data);
          context.commit("set_has_other_data", false);
          return data;
        }
      })
      .catch((reason) => {
        console.info("search catch", reason);
        context.commit("set_results", []);
      });
  },
};
